var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasurementTwoPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "m 13.33612,1.3365 c -0.736133,0 -1.332367,0.5962342 -1.332367,1.3323669 0,0.2464879 0.06995,0.4729902 0.186532,0.6728453 L 3.3400565,12.185298 C 3.1435324,12.068715 2.9136991,11.998766 2.6672112,11.998766 c -0.7361327,0 -1.3323669,0.596234 -1.3323669,1.332367 0,0.736133 0.5962342,1.332367 1.3323669,1.332367 0.7361327,0 1.3323669,-0.596234 1.3323669,-1.332367 0,-0.246488 -0.07328,-0.476321 -0.1898623,-0.672846 L 12.659944,3.8180334 c 0.199854,0.116582 0.426357,0.1898622 0.672845,0.1898622 0.736132,0 1.332367,-0.5962341 1.332367,-1.3323669 0,-0.7361327 -0.596235,-1.3323668 -1.332367,-1.3323668 z",
    style: {
      strokeWidth: 0.666183
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementTwoPoint);
export default __webpack_public_path__ + "static/media/measurementTwoPoint.776c7b39be0af19813febfcfda9379b5.svg";
export { ForwardRef as ReactComponent };